export default __webpack_public_path__ + "static/media/fNeutral7.cf62f1e3.png";